import React, { useEffect, useRef, useState } from 'react';
// import Navbar from './Navbar'
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';

const SmallScreensNavbar = ({ onClick, navClass, linkClassName, handleNavClick }) => {
    let [translate, setTranslate] = useState(true);
    const [openSolution, setOpenSolution] = useState(false);
    const [openIndustries, setOpenIndustries] = useState(false);
    const [openResources, setOpenResources] = useState(false);
    const [openCompany, setOpenCompany] = useState(false);
    const sidebarRef = useRef(null);

    const handleSectionClick = (value) => {
        if (value === 'solutions') setOpenSolution(!openSolution);
        if (value === 'industries') setOpenIndustries(!openIndustries);
        if (value === 'resources') setOpenResources(!openResources);
        if (value === 'company') setOpenCompany(!openCompany);

        if (translate) {
            setOpenSolution(false);
            setOpenIndustries(false);
            setOpenResources(false);
            setOpenCompany(false);
        }
    }

    const handleTranslate = () => {
        const newTranslateValue = !translate;
        setTranslate(newTranslateValue);
        
        // if (newTranslateValue) {
        //     closeAllDropdowns();
        // }
    }

    //to close the menus in sidebar
    // const closeAllDropdowns = () => {
    //     setOpenSolution(false);
    //     setOpenIndustries(false);
    //     setOpenResources(false);
    //     setOpenCompany(false);
    // };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!translate && 
                sidebarRef.current && 
                !sidebarRef.current.contains(event.target) &&
                !event.target.closest('.hamburger-btn')) {
                setTranslate(true);
                // closeAllDropdowns();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [translate]);

    return (
        <div>
            <button className="hamburger-btn"
                onClick={handleTranslate}>
                {translate ? <span>&#9776;</span> : <span>&times;</span>}
            </button>

            <div ref={sidebarRef} id="sidebar-list" className={`${translate ? "addTransiton" : "removeTransition"}`} >
                <div>
                    <RouterLink 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={handleSectionClick}
                        smooth="true" to='/'
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>HOME</b>
                        </div>
                    </RouterLink>
                </div>
                <div>
                    <div 
                        style={{color:'#fff',}} className={`${linkClassName} linkClassName`} onClick={()=>handleSectionClick('solutions')}
                        smooth="true"
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b> SOLUTIONS</b>
                            <div className='arrow-svg small-screen-arrow-svg' style={{ transform:`rotate(${openSolution ? '90deg' : '0deg'})`}}>
                                <KeyboardArrowRightSharpIcon style={{fontSize:'18px'}}/>
                            </div>
                        </div>
                    </div>
                    { openSolution && 
                    <div style={{color:'#fff'}} > 
                        <ul className='sidebar-ul'>
                            <li><RouterLink className='sidebar-li' to='/lims'>LIMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/eln'>ELN</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/qms'>QMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/dms'>DMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/lms'>LMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/elog'>E-Logbook</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/ipqc'>IPQC</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/vms'>VMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/adbs'>ADBS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/lims-eln'>LIMS-ELN</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/tlims'>T-LIMS</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/saas'>SAAS</RouterLink></li>
                        </ul>
                    </div> }
                </div>

                <div>
                    <Link 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={()=>handleSectionClick('industries')}
                        smooth="true"
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>INDUSTRIES</b>
                            <div className='arrow-svg small-screen-arrow-svg' style={{ transform:`rotate(${openIndustries ? '90deg' : '0deg'})`}}>
                                <KeyboardArrowRightSharpIcon style={{fontSize:'18px'}}/>
                            </div>
                        </div>
                    </Link>
                    { openIndustries && 
                    <div style={{color:'#fff'}} > 
                        <ul className='sidebar-ul'>
                            <li><RouterLink className='sidebar-li' to='/pharma'>Pharmaceutical</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/biotech'>Biotechnology</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/cro-cdmo'>CRO/CDMO</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/foodindustry'>Food Technology</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/academia'>Academia</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/startup'>Start up</RouterLink></li>
                        </ul>
                    </div> }
                </div>

                <div>
                    <Link 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={()=>handleSectionClick('resources')}
                        smooth="true"
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>RESOURCES</b>
                            <div className='arrow-svg small-screen-arrow-svg' style={{ transform:`rotate(${openResources ? '90deg' : '0deg'})`}}>
                                <KeyboardArrowRightSharpIcon style={{fontSize:'18px'}}/>
                            </div>
                        </div>
                    </Link>
                    { openResources && 
                    <div style={{color:'#fff'}} > 
                        <ul className='sidebar-ul'>
                            {/* <li><RouterLink className='sidebar-li' to='/whitepapers'>White Papers</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/webinars'>Webinars</RouterLink></li> */}
                            <li><RouterLink className='sidebar-li' to='/blogs'>Blogs</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/downloads'>Brochure</RouterLink></li>
                        </ul>
                    </div> }
                </div>

                <div>
                    <Link 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={()=>handleSectionClick('company')}
                        smooth="true"
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>COMPANY</b>
                            <div className='arrow-svg small-screen-arrow-svg' style={{ transform:`rotate(${openCompany ? '90deg' : '0deg'})`}}>
                                <KeyboardArrowRightSharpIcon style={{fontSize:'18px'}}/>
                            </div>
                        </div>
                    </Link>
                    { openCompany && 
                    <div style={{color:'#fff'}} > 
                        <ul className='sidebar-ul'>
                            <li><RouterLink className='sidebar-li' to='/about'>About</RouterLink></li>
                            <li><RouterLink className='sidebar-li' to='/careers'>Careers</RouterLink></li>
                        </ul>
                    </div> }
                </div>

                <div>
                    <RouterLink 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={handleSectionClick}
                        smooth="true" to='/saas-form'
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>SUBSCRIBE</b>
                        </div>
                    </RouterLink>
                </div>

                <div>
                    <RouterLink 
                        style={{color:'#fff'}} className={`${linkClassName} linkClassName`} onClick={handleSectionClick}
                        smooth="true" to='/demo'
                    >
                        <div className='text-start sidebar-section' style={{display :'flex', alignItems:'center'}}>
                            <b>GET A DEMO</b>
                        </div>
                    </RouterLink>
                </div>
            </div>
        </div>
    )
}
export default SmallScreensNavbar;
